import { defineComponent } from './vue.esm-browser.prod.js';
import { html } from './helper-functions.js';


export default defineComponent({
  props: {
    option: { type: Object, required: true },
    isSelected: { type: Boolean, default: false },
    isButton: { type: Boolean, default: false },
  },

  // @ts-ignore
  setup(props, { emit }) {
    function handleDropdownOptionChange() {
      emit('dropdown-option-click', props.option);
    }

    return { handleDropdownOptionChange };
  },

  template: html`
    <li class="DropdownOption" @click="handleDropdownOptionChange">
      <div v-if="!isButton" class="DropdownOption__radio-outer-circle">
        <div class="DropdownOption__radio-inner-circle" :class="{ 'is-active': isSelected }" />
      </div>
      <div class="DropdownOption__slot-container">
        <slot/>
      </div>
    </li>
  `,
});